<div class="patient-list-content">
  <div class="form-line m-b-0">
    <mat-form-field *ngIf="!showSearch" class="full-width" (click)="onclickSelectedInput()" appearance="outline">
      <input matInput autocomplete="off" [value]="patientFullName"
        [placeholder]="patient?.id?'Пациент':'Выберите пациент'" matInput>
      <button matSuffix mat-icon-button aria-label="Поиск пациента">
        <mat-icon>keyboard_arrow_down</mat-icon>
      </button>
      <button (click)="clearValue($event)" matSuffix mat-icon-button aria-label="Очистить">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
  </div>
  <div class="tab-content" *ngIf="showSearch">
    <mat-form-field class="full-width" appearance="outline">
      <input #searchinput (input)="search($event)" placeholder="{{'CLINIC_PATIENT.SEARCH'|translate}}" matInput autocomplete="off">
      <button (click)="closeSearch()" matSuffix mat-icon-button aria-label="Поиск пациента">
        <mat-icon>close</mat-icon>
      </button>
      <div>
        <div class="progress-bar-content">
          <div *ngIf="isLoading">
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          </div>
        </div>
        
  
        <div *ngIf="patients.length; else emptyPatients">
          <div id="clinic_patient_search_result" [perfectScrollbar] [style.max-height.px]="height">
            <ul class="patient-item-list  list-unstyled m-b-0">
              <ng-container *ngFor="let item of patients">
                <li class="clearfix" [class.active]="item.id===patient?.id" (click)="onSelect($event, item)">
                  <div class="d-flex align-items-center">
                    <img src="assets/images/user/user1.jpg" alt="avatar">
                    <div class="about">
                      <div class="name">{{item.lastName}} {{item.firstName}} {{item.middleName}}</div>
                      <div class="status">
                        {{item.phoneNumber??item.email}} </div>
                    </div>
                  </div>
                </li>
              </ng-container>
            </ul>
          </div>
        </div>
      </div>
    </mat-form-field>
   
  </div>
  <ng-template #emptyPatients>
    <div class="emptyPatient-content">

    </div>
  </ng-template>
</div>